import { Component, OnInit } from "@angular/core";
import { FormControl } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { debounceTime } from "rxjs";
import { DEBOUNCE_TIME2 } from "src/app/models/consts";
import { ModuleType } from "src/app/models/enums";
import { PopupService } from "src/app/services/shared/popup.service";
import { StateService } from "src/app/services/shared/state.service";

@Component({
  selector: "app-ads",
  templateUrl: "./ads.component.html",
})
export class AdsComponent implements OnInit {
  keyword: string = "";
  selectedCategoryIds: number[] = [0];
  selectedCountryIds: number[] = [0];

  selectedNetworkId: number = 0;
  selectedCategoryId: number = 0;
  selectedCountryId: number = 0;
  selectedLanguageId: string = "en";
  selectedDurationId: string = "";
  selectedStatusId: string = "unlisted";

  isPayingUser: boolean = false;
  openedYtVideoId: string = "";
  inputControl: FormControl = new FormControl();

  firstLoad: boolean = true;

  constructor(
    public stateService: StateService,
    public router: Router,
    public popupService: PopupService,
    public route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.stateService.TabSelected("ads");
    this.stateService.ModuleSelected(ModuleType.Marketer);
    this.GetSearchKeyword();
    this.SubscribeFormControl();
    this.SubscribeToUser();
  }

  public UpdateRoute() {
    this.router.navigate([], {
      queryParams: {
        keyword: this.keyword,
        ...(this.openedYtVideoId && { videoId: this.openedYtVideoId }),
      },
      replaceUrl: true,
    });
  }

  public GetSearchKeyword() {
    this.route.queryParams.subscribe((params) => {
      this.keyword = params["keyword"];
      this.inputControl.patchValue(this.keyword);
      if (params["videoId"] && this.firstLoad == true) {
        this.openedYtVideoId = params["videoId"];
        this.OpenVideoModal();
      }
      this.firstLoad = false;
    });
  }

  private SubscribeFormControl() {
    this.inputControl.valueChanges
      .pipe(debounceTime(DEBOUNCE_TIME2))
      .subscribe(() => {
        this.keyword = this.inputControl.value;
        this.UpdateRoute();
      });
  }

  public SubscribeToUser() {
    this.stateService.user$.subscribe((user) => {
      this.isPayingUser = this.stateService.IsPayingUserState(user);
    });
  }

  public SelectedCategoriesChanged(selected: number[]) {
    this.selectedCategoryIds = selected;
  }

  public RemoveAllCategories() {
    this.selectedCategoryIds = [0];
  }

  public SelectedCountryChanged(countryId: number) {
    this.selectedCountryId = countryId;
  }

  public SelectedLanguageChanged(languageId: string) {
    this.selectedLanguageId = languageId;
  }

  public SelectedStatusChanged(videoStatusId: string) {
    this.selectedStatusId = videoStatusId;
  }

  public SelectedDurationChanged(durationId: string) {
    this.selectedDurationId = durationId;
  }

  public RemoveCategory(id: number) {
    if (this.selectedCategoryIds.length == 1) {
      this.selectedCategoryIds = [0];
      return;
    }
    this.selectedCategoryIds = this.selectedCategoryIds.filter((i) => i != id);
  }

  public RemoveCountry(id: number) {
    this.selectedCountryId = 0;
  }

  public RemoveLanguage(id: string) {
    this.selectedLanguageId = "";
  }

  public RemoveDuration(durationId: string) {
    this.selectedDurationId = "";
  }

  public VideoModalOpened(ytVideoId: string) {
    this.openedYtVideoId = ytVideoId;
    this.UpdateRoute();
  }

  public VideoModalClosed() {
    this.openedYtVideoId = "";
    this.UpdateRoute();
  }

  public OpenVideoModal() {
    this.popupService.openVideoInfoModal(
      this.openedYtVideoId,
      () => this.VideoModalClosed(),
      () => {}
    );
  }
}
